import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class BlogpageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  blogData: any;
  articleData: any;

  private blogFeaturedBlogContentPanelSubject$ = new BehaviorSubject<any>(null);
  public blogFeaturedBlogContentPanel$ =
    this.blogFeaturedBlogContentPanelSubject$.asObservable();
  private blogHeaderSubject$ = new BehaviorSubject<any>(null);
  public blogHeader$ = this.blogHeaderSubject$.asObservable();
  private blogAllTagsSubject$ = new BehaviorSubject<any>(null);
  public blogAllTags$ = this.blogAllTagsSubject$.asObservable();
  private articlePageDataSubject$ = new BehaviorSubject<any>(null);
  public articlePageData$ = this.articlePageDataSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getBlogPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.blogPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.blogData = mod[0].fields;
        const featuredBlogContentPanelData =
          this.blogData.featuredBlogContentPanel.fields;
        const blogHeaderData = this.blogData.title;
        if (featuredBlogContentPanelData) {
          this.blogFeaturedBlogContentPanelSubject$.next(
            featuredBlogContentPanelData
          );
        }
        if (blogHeaderData) {
          this.blogHeaderSubject$.next(blogHeaderData);
        }
        const allTagsData = this.blogData;
        if (allTagsData) {
          this.blogAllTagsSubject$.next(allTagsData);
        }
        const getStarted = this.blogData.gettingStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }

  getBlogListBySearch(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.blogArticle,
          query: query,
        })
      )
      .then(res => res.items);
  }

  getBlogListByTag(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.blogArticle,
          'fields.category': query,
        })
      )
      .then(res => res.items);
  }
  getAllBlogArticles(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          content_type: PageId.blogArticle,
          limit: 1000,
          include: 10
        })
      )
      .then(res => {
        return res.items;
      });
  }
  getArticleByID(query: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.blogArticle,
          'fields.blogId': query,
        })
      )
      .then(res => {
        return res.items;
      });
  }

  getArticleData(id: any) {
    this.getArticleByID(id).then(data => {
      if (data) {
        this.articleData = data[0];
        if (this.articleData) {
          this.articlePageDataSubject$.next(this.articleData);
        }
        const seo = this.articleData?.fields?.seoMetadataReference?.fields;
        if (seo) {
          this.meta.updateMeta(seo);
        }
      }
    });
  }
}
